export const AGGREGATOR_SERVICE_ENDPOINT = {
  REVENUE_COUNT: '/revenueDetails',
  TOP_SELLING_PRODUCTS: '/topSellingProducts'
};